import { createSelector } from 'reselect';
import { pipe, flow } from 'fp-ts/function';
import { keyBy, getStringProp } from '@mews/fp';
import { createAction, createReducer } from '@mews/framework';
import { ApplicationState } from '@mews-commander/types';
import { ApplicationPermissionAssignment } from '@mews-commander/data-access';
import prefix from '../prefix';
import moduleSelectorJS from '../selector';
import { Entities } from './utils';

export const NAME = 'applicationPermissions';
const APPLICATION_PERMISSIONS_SET = prefix('APPLICATION_PERMISSIONS_SET');
interface EntitiesState {
    [NAME]: ApplicationPermissionsState;
}

type ApplicationPermissionsState = Entities<ApplicationPermissionAssignment>;

type ModuleSelector = (state: ApplicationState) => EntitiesState;
const moduleSelector = moduleSelectorJS as unknown as ModuleSelector;

export const setApplicationPermissions = (applicationPermissions: Array<ApplicationPermissionAssignment>) =>
    createAction(APPLICATION_PERMISSIONS_SET, applicationPermissions);

export const applicationPermissionsReducer = createReducer(
    {},
    {
        [APPLICATION_PERMISSIONS_SET]: (
            state: ApplicationPermissionsState,
            applicationPermissions: Array<ApplicationPermissionAssignment>
        ) => ({
            ...state,
            ...pipe(applicationPermissions, keyBy('identifier')),
        }),
    }
);

const getApplicationPermissions = flow(moduleSelector, (entities) => entities[NAME]);

export const getSingleApplicationPermissions = createSelector(
    getApplicationPermissions,
    getStringProp('id'),
    (permissions, id) => (permissions[id] ? permissions[id].permissionValues : undefined)
);
